import React, { useState } from 'react';
import { ViewOnlyTooltip } from '../ViewOnlyTooltip';
import { useIntl } from 'react-intl';
import { Box, List, ListItemText, MenuItem, Select, Tooltip } from '@fullstory/components';

export const testIds = {
  EXPORT_DROPDOWN_SELECT: 'export-dropdown-select',
  EXPORT_DROPDOWN_ITEM: 'export-dropdown-item',
};

export interface ExportOption {
  id: string;
  text: string;
  onSelect: () => void;
  disabled?: boolean;
  disabledText?: string;
}

export interface ExportDropdownProps {
  options: ExportOption[];
  canExport: boolean;
}

export function ExportDropdown({ options, canExport }: ExportDropdownProps) {
  const intl = useIntl();
  const [open, setOpen] = useState(false);
  const [highlightedSectionId, setHighlightedSectionId] = useState<string | null>(null);

  return (
    <ViewOnlyTooltip isViewOnly={!canExport}>
      <Select
        disabled={!canExport}
        open={open}
        displayName={intl.formatMessage({ defaultMessage: 'Export', id: 'SVwJTM' })}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        variant="outline"
        placement="bottom-end"
        testId={testIds.EXPORT_DROPDOWN_SELECT}
      >
        <Box width={160}>
          <List>
            {options.map(option => (
              <Tooltip
                key={option.id}
                disabled={!option.disabled || !option.disabledText}
                tooltipContent={option.disabledText}
              >
                <MenuItem
                  onClick={() => {
                    setOpen(false);
                    option.onSelect();
                  }}
                  onMouseLeave={() => setHighlightedSectionId(null)}
                  onMouseEnter={() => setHighlightedSectionId(option.id)}
                  highlighted={highlightedSectionId === option.id}
                  disabled={option.disabled}
                  testId={`${testIds.EXPORT_DROPDOWN_ITEM}-${option.id}`}
                >
                  <ListItemText text={option.text} />
                </MenuItem>
              </Tooltip>
            ))}
          </List>
        </Box>
      </Select>
    </ViewOnlyTooltip>
  );
}
